import React, { useEffect, Suspense, lazy } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import MobileCallBar from './components/MobileCallBar';

// Lazy load pages for performance
const Home = lazy(() => import('./pages/Home'));
const ServicePage = lazy(() => import('./pages/ServicePage'));
const TeamMemberPage = lazy(() => import('./pages/TeamMemberPage'));
const LegalPage = lazy(() => import('./pages/LegalPage'));

// Simple loading fallback
const PageLoader = () => (
  <div className="min-h-[60vh] flex items-center justify-center">
    <div className="w-12 h-12 border-4 border-teal-100 border-t-teal-600 rounded-full animate-spin"></div>
  </div>
);

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

function App() {
  return (
    <Router>
      <ScrollToTop />
      <div className="min-h-screen flex flex-col font-sans text-gray-900 bg-white">
        <Navbar />
        <main className="flex-grow pb-24 lg:pb-0">
          <Suspense fallback={<PageLoader />}>
            <Routes>
              <Route path="/" element={<Home />} />
              
              {/* Service Routes */}
              <Route path="/back-pain" element={<ServicePage serviceId="back-pain" />} />
              <Route path="/neck-pain" element={<ServicePage serviceId="neck-pain" />} />
              <Route path="/headaches-migraines" element={<ServicePage serviceId="headaches-migraines" />} />
              <Route path="/massage" element={<ServicePage serviceId="massage" />} />
              <Route path="/lymphatic-drainage" element={<ServicePage serviceId="lymphatic-drainage" />} />
              <Route path="/myofascial-dry-needling" element={<ServicePage serviceId="myofascial-dry-needling" />} />
              <Route path="/x-rays" element={<ServicePage serviceId="x-rays" />} />
              <Route path="/custom-orthotics" element={<ServicePage serviceId="custom-orthotics" />} />
              
              {/* Team Routes */}
              <Route path="/team/:slug" element={<TeamMemberPage />} />
              
              {/* Legal Routes */}
              <Route path="/privacy-policy" element={<LegalPage pageId="privacy-policy" />} />
              <Route path="/terms-of-service" element={<LegalPage pageId="terms-of-service" />} />
            </Routes>
          </Suspense>
        </main>
        <MobileCallBar />
        <Footer />
      </div>
    </Router>
  );
}

export default App;